import { useQuery } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { supabase } from "@/integrations/supabase/client";

export const creditBalanceQueryKey = (workspaceId: string | undefined) =>
  ["credit-balance", workspaceId] as const;

export function useCreditBalance(workspaceId: string | undefined) {
  return useQuery({
    queryKey: creditBalanceQueryKey(workspaceId),
    enabled: Boolean(workspaceId),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    queryFn: async (): Promise<number> => {
      if (!workspaceId) return 0;
      const { data, error } = await supabase.rpc("get_workspace_credit_balance", {
        p_workspace_id: workspaceId,
      });
      if (error) {
        // RPC failures here are unexpected — get_workspace_credit_balance just
        // sums credit_ledger and is gated by RLS that lets workspace members
        // read. Surface to Sentry so a real outage doesn't silently render as
        // "0 credits" in the header. Caller decides how to display the error.
        console.error("get_workspace_credit_balance failed:", error);
        Sentry.captureException(error, { tags: { workspace_id: workspaceId } });
        throw error;
      }
      return typeof data === "number" ? data : 0;
    },
  });
}
